import React, {useContext, useState} from "react";

import {ContextProvider} from "../App"

// import from react-router
import { NavLink, useHistory } from "react-router-dom";

// import images
import Logo from "../images/logo.svg";
import Offer from "../images/offericon.svg";
import Help from "../images/helpicon.svg";
// import Cart from "../images/cart.svg";
import Hamburger from "../images/hamburger.svg";

function Header() {
  // const { pathname } = useLocation(); // get URL path from browser's address bar 
  const history = useHistory(); // get URL history from browser's address bar '
  const { modalsDispatch, isMobile } = useContext(ContextProvider); // get state from app
  const [openHeader, setOpenHeader] = useState(false);

  const handleHeaderSignUp = () => {
    history.push("/")

    setTimeout(() => {                    // setTimeout function to delay the sign up drawer from some sec
      modalsDispatch({ type: "OPEN_SIGN_UP" })
    }, 100);
  }

  return (
    <>
      
      <div className="header_full_container">
        <div className="header_container">
          <div className="header_logo_img">
            <NavLink to="/">
              <img src={Logo} alt="offer" className="header_logo" />
            </NavLink>
          </div>
          <ul className="header_ul">
            <li className="header_items">
              <img src={Offer} alt="offer" style={{ marginRight: ".5rem" }} />
              <span>Offer</span>
            </li>
            <li className="header_items">
              <img src={Help} alt="offer" style={{ marginRight: ".5rem" }} />
              <span>Help</span>
            </li>
            <li className="header_items_box">
              <button
                type="button"
                className="header_signUp_btn"
                onClick={handleHeaderSignUp}
              >
                Sign Up
              </button>
            </li>
            {isMobile && (
              <li className="header_items_box">
                <img src={Hamburger} alt="Hamburger" onClick={ ()=>setOpenHeader(!openHeader)}/>
              </li>
            )}
          </ul>
        </div>
      </div>
      {openHeader && (
        <div className="mobile_header_box">
          <ul className="responsive_header_ul">
            <li className="responsive_header_items">
              <img src={Offer} alt="offer" height="17" style={{ marginRight: ".8rem" }} />
              <span>Offer</span>
            </li>
            <li className="responsive_header_items">
              <img src={Help} alt="offer" height="20" style={{ marginRight: "1rem", }} />
              <span>Help</span>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

export default Header;
